import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectInnovation, innovationListUpdateSelected } from "../../app/actions/innovationActions";
import { registerPanelViewInterest } from "../../app/helpers/intentTrackingHelper";
import ReadMoreReadLess from "../generic-read-more/ReadMoreReadLess";
import L5ModalInnovation from "./L5ModalInnovation";
import { debugLogPages } from "../../app/helpers/debugHelper";
import { useTranslation } from "react-i18next";
import SemanticSimilarityBadge from "./SemanticSimilarityBadge";

const L4CardInnovation = ({ data, moduleSelected }) => {

 debugLogPages(":: L4CardInnovation");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { comparisonInnovationCheckEnabled } = useSelector((state) => state.configuration);
  const [checked] = useState(false);
  const [popupInformationTechIsOpen, setPopupInformationTechIsOpen] = useState(false);

  const isChecked = data.isSelected;

  const handleToggle = () => {
      dispatch(innovationListUpdateSelected(data.id));
    };

  const closeModal = () => {
    setPopupInformationTechIsOpen(false);
  }

  const handleViewInnovation = (e) => {
    e.preventDefault();
    dispatch(selectInnovation(data));
    registerPanelViewInterest(dispatch, 'innovation', data);
    navigate(`/end-user-search/preview-innovation`);
  };

  const PreviewImageShow = () => {
  // Imagen por defecto
  //const defaultImg = "/Modulos/TecBC.png";
  const defaultImg = '/images/logo_teccc_no_disponible.png'

  const handleImgError = (e) => {
    // Si la imagen falla, reemplazamos el src por la de defecto
    e.target.src = defaultImg;
    // Opcional: puedes quitar el atributo onError para evitar bucles si la de defecto también falla
    e.target.onerror = null; 
  };

  if (data.ModuleFile_To_Innovation && data.ModuleFile_To_Innovation.length > 0) {
    return (
      <img 
        src={data.ModuleFile_To_Innovation[0].url} 
        alt="file" 
        onError={handleImgError} // <-- El truco está aquí
      />
    );
  } else {
    return (
      <div>
        <img src={defaultImg} width="300px" alt="technology" />
      </div>
    );
  }
};

  const handlePopupSwall = (e) => {
    e.preventDefault();
    registerPanelViewInterest(dispatch, 'innovation', data);

    setPopupInformationTechIsOpen(true);
  };

  return (
    <li className="cards__item">
      <div className="card"

      >
        {comparisonInnovationCheckEnabled === "true" && <div>
          <label>
            <input
              type="checkbox"
              checked={isChecked} 
              onChange={handleToggle}
            />
            <div className="espacioComparar">{checked ? `${t('general.card-selected')}` : `${t('general.card-select')}`}</div>
          </label>
        </div>}
        <div className="card__image" onClick={handlePopupSwall}>
          <PreviewImageShow />
        </div>
        <div className="card__content">
          <SemanticSimilarityBadge data={data} moduleKey="innovation" />
          <div className="card__title">
            <ReadMoreReadLess
              className='read-more-less'
              buttonClassName='btn-read-more-less'
              expandLabel="Leer más" 
              collapseLabel="Leer menos" 
              limit={100}
            >
              {data && data.name}
            </ReadMoreReadLess>
          </div>
          <br />
          <div className="card__text">
            <ReadMoreReadLess
              className='read-more-less'
              buttonClassName='btn-read-more-less'
              expandLabel="Leer más" 
              collapseLabel="Leer menos" 
              limit={100}
            >
              {data && data.purpose}
            </ReadMoreReadLess>
          </div>
          <button className="btn btn--block button-color-view" onClick={handleViewInnovation}>
            {t("buttons.view")}
          </button>

        </div>
      </div>

      <L5ModalInnovation
        modalIsOpen={popupInformationTechIsOpen}
        closeModal={closeModal}
        data={data}
        moduleSelected={moduleSelected}
      />

    </li>
  );
};

export default L4CardInnovation;
